import React, { useState } from 'react'
import disabledArrow from '@assets/btn-arrowRight-disabled.svg'
import enabledArrow from '@assets/btn-arrowRight-enabled.svg'
import pressedArrow from '@assets/btn-arrowRight-hover.svg'
import { withAutoBlur } from '../../utils/misc'

interface ArrowButtonProps {
    id: string
    direction: string
    disabled: boolean
    onClick: (direction: string) => void
    style?: object
    className?: string
}

/**
 * ArrowButton component
 *
 * Props:
 * - direction: 'right' (default) or 'left'
 * - disabled: disables the button if true
 * - onClick: function to call on click (only if not disabled)
 * - style: custom inline styles for the button
 * - className: additional CSS classes for the button
 */
const ArrowButton: React.FC<ArrowButtonProps> = ({
    id,
    direction = 'right',
    disabled = false,
    onClick,
    style,
    className,
}) => {
    const [pressed, setPressed] = useState(false)

    const handleMouseDown = () => {
        if (!disabled) {
            setPressed(true)
        }
    }

    const handleMouseUp = () => {
        if (!disabled) {
            setPressed(false)
        }
    }

    let svgSrc = ''

    if (disabled) {
        svgSrc = disabledArrow
    } else if (pressed) {
        svgSrc = pressedArrow
    } else {
        svgSrc = enabledArrow
    }

    // If the desired arrow is left, flip the right arrow SVG using CSS
    const flipStyle = direction === 'left' ? { transform: 'scaleX(-1)' } : {}

    return (
        <button
            id={id}
            className={className}
            style={{
                // Remove default button styling
                border: 'none',
                background: 'none',
                padding: 0,
                cursor: disabled ? 'default' : 'pointer',
                ...style,
            }}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp} // In case the pointer leaves the button while pressed
            onClick={!disabled ? withAutoBlur(() => onClick(direction)) : undefined}
            disabled={disabled}
        >
            <img src={svgSrc} alt={`${direction} arrow`} style={flipStyle} draggable="false" />
        </button>
    )
}

export default ArrowButton
